import { createBrowserRouter } from 'react-router'
import { allNavItems } from '@/config/navigation'
import { LoginPage } from '@/features/auth/LoginPage'
import { PasswordResetPage } from '@/features/auth/PasswordResetPage'
import { AppShell } from '@/layout/AppShell'
import { NotFoundPage, RedirectIfAuthenticated, RequireAuth, RouteGate } from './guards'
import { RouteError } from './RouteError'

export const router = createBrowserRouter([
  {
    path: '/login',
    errorElement: <RouteError />,
    element: (
      <RedirectIfAuthenticated>
        <LoginPage />
      </RedirectIfAuthenticated>
    ),
  },
  {
    path: '/reset-password',
    errorElement: <RouteError />,
    element: (
      <RedirectIfAuthenticated>
        <PasswordResetPage />
      </RedirectIfAuthenticated>
    ),
  },
  {
    errorElement: <RouteError />,
    element: (
      <RequireAuth>
        <AppShell />
      </RequireAuth>
    ),
    children: [
      ...allNavItems.map((item) => ({
        path: item.path,
        element: <RouteGate key={item.id} item={item} />,
      })),
      { path: '*', element: <NotFoundPage /> },
    ],
  },
])
